$(document).ready(function () {
	if (typeof common !== 'undefined') {
		common.initIsMobile();
		common.MrHeader1.init();
		common.MrHellobar1.init();
		common.initResendRecoverCode();
		common.initExample1SliderSwiper();
		common.initVisual43SliderSwiper();
		common.initHideReadonlyInputCursor();
		common.initExamplesMenu();
		common.initExampleMenu();
		common.initSmoothScroll();
		common.initBranch.init();
		common.initEmbedLayer();
		common.sendEventAfterClick();
		common.initLoginBtnWithEmail();
		common.initSocialBtnsTos();
		common.templateActionsWorker.init();
		common.initLiveEmbedLogin();
		common.cookieConsentBannerPosition.init();
		common.sendEventsToEventHubAfterABTestInit.init();
		common.notificationBanner.init();
	}
});